import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        gap: '25px',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        padding: '10px',
    },
    selectButton: {
        justifyContent: 'end',
        height: '100%',
        width: 'max-content',
        textTransform: 'capitalize',
        fontSize: '14px',
        padding: '0px 5px 0px 5px',
    },
}));
